
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M508.054 416.813l-22.498 22.499 22.453 22.453c4.946 4.946 5.288 12.628.752 17.142-4.514 4.536-12.195 4.194-17.142-.752l-22.453-22.453-22.556 22.544c-4.946 4.946-12.617 5.288-17.142.775-4.524-4.536-4.183-12.207.764-17.153l22.556-22.556-22.602-22.612c-4.946-4.936-5.288-12.606-.775-17.143 4.537-4.514 12.207-4.171 17.143.764l22.612 22.602 22.51-22.499c4.936-4.946 12.617-5.288 17.142-.752 4.525 4.513 4.183 12.194-.764 17.141zm-141.489 31.798a99.53 99.53 0 0010.35 44.291H.49c-.313-4.377-.49-8.798-.49-13.244 0-75.451 45.373-141.728 113.775-179.487a254.826 254.826 0 0121.342-10.509c30.061 24.915 68.715 39.914 110.903 39.914 42.063 0 80.608-14.908 110.63-39.686 7.328 3.214 14.452 6.725 21.324 10.554 17.814 9.882 34.044 21.724 48.337 35.149a.153.153 0 01-.068.023c.022 0 .046-.012.068-.023a221.205 221.205 0 0115.409 15.979c-43.241 11.296-75.155 50.458-75.155 97.039zM246.214 298.074c-77.423 0-140.188-62.447-140.188-139.489 0-77.036 62.766-139.488 140.188-139.488 77.43 0 140.195 62.452 140.195 139.488 0 77.042-62.765 139.489-140.195 139.489z"}})])
          )
        }
      }
    